import { observable, action, computed } from "mobx";
import FirebaseService from "./../services/impl/firebase/FirebaseService";

class PresenterMeetingStore {
  prevSlideChangeTs = new Date().getTime();
  @observable meeting = { 
    title: "",
    presentation: {
      slides: []
    } 
  };
  @observable errorObject = {
    errorCode: "",
    errorMessage: "",
  };

  constructor(rootStore) {
    this.rootStore = rootStore;
  }

  @action loadMeeting = (userId, meetingId) => {
    FirebaseService.getInstance()
      .meeting(userId, meetingId).on("value", (snapshot) => {
        this.meeting = snapshot.val();
        this.meeting.uid = snapshot.key;
      });
  };

  @action startMeeting = (authUser, audioOpted) => {
    const ref = "/users/" + authUser.uid + "/meetings/" + this.meeting.uid;
    const startTime = new Date().getTime();
    this.updateAttribute(ref, "status", "STARTED");
    this.updateAttribute(ref, "actualStartTime", startTime);
    this.setAudioOpted(authUser.uid, audioOpted);
    //Event. Should store the time duration between presenter and the participant join time
    //FirebaseService.getInstance().sendMeetingEvent(this.meeting, 'MEETING_STARTED', {userId: userId, duration: (startTime - this.meeting.actualStartTime)});
  };

  @action setAudioOpted = (userId) => {
    const ref = "/users/" + userId + "/meetings/" + this.meeting.uid;
    this.updateAttribute(ref, "useAudio", false);
  };

  updateAttribute = (refPath, attrName, attrValue) => {
    const updateObj = {};
    updateObj["" + attrName] = attrValue;
    FirebaseService
      .getInstance()
      .database()
      .ref(refPath)
      .update(updateObj, function (error) {
        if (error) {
          this.errorObject = {
            errorMessage: "Couldnot start meeting. Failed!",
          };
        } else {
          // Data saved successfully!
        }
      });
  };

  @action goToSlide = (authUser, slideNo) => {
    const ref = "users/" + authUser.uid + "/meetings/" + this.meeting.uid + "/presentation";
    this.updateAttribute(ref, "currentSlide", slideNo);
    //Event
    const slideChangeTs = new Date().getTime();
    // const duration = slideChangeTs - this.prevSlideChangeTs;
    // FirebaseService.sendSlideChangeEvent(this.meeting, authUser.uid, duration);
    this.prevSlideChangeTs = slideChangeTs;
  };

  @action endMeeting = (authUser) => {
    const ref = "/users/" + authUser.uid + "/meetings/" + this.meeting.uid;
    const endTime = new Date().getTime();
    this.updateAttribute(ref, "status", "END");
    this.updateAttribute(ref, "actualEndTime", endTime);
    const audioRef = "/users/" + authUser.uid + "/meetings/" + this.meeting.uid + "/presenter/audio";
    this.updateAttribute(audioRef, "optedIn", false);
    this.updateAttribute(audioRef, "status", "OFFLINE");
    //if (this.rootStore.presenterMeetingStore.meeting.useAudio) {
      this.rootStore.presenterControlStore.leaveAudio(
        this.meeting.uid
      );
    //}
  };

  @action updateCanvas = (authUser, draw) => {
    const ref = "/users/" + authUser.uid + "/meetings/" + this.meeting.uid;
    this.updateAttribute(ref, "canvasData", draw);
  };

  /**
   * Register listeners for activieis in the meeting object
   */
  @action registerMeetingListeners = (firebase) => {};

  _participantJoined = () => {};

  _participantLeft = () => {};
}

export default PresenterMeetingStore;
